export const calendarLayout = {
  dayHeaderHeight: 24,
  dayPadding: 16,
  reservationRowHeight: 20,
};
